import React, { useState, useEffect, useContext } from 'react';
import { postPhotos, createAvatar } from '../../services/measureSvc';
import { getMeasurements, saveMeasurements } from '../../services/measureSvc';
import { dataURItoBlob } from '../../services/imageSvc';
import {findMetricVal} from '../../services/metricsSvc'

import FlowStageTakePhotos from './components/FlowStageTakePhotos';
import FlowStageChooseFlowType from './components/FlowStageChooseFlowType';
import FlowStageVerifyPhotos from './components/FlowStageVerifyPhotos';
import FlowStageInputMetric, { HeightDefaults, WeightDefaults } from './components/FlowStageInputMetric';
import FlowStageError from './components/FlowStageError';
import { CameraContext } from '../../contexts/CameraContext';
import * as FlowState from '../../enums/flow-state';
import * as Orientations from '../../enums/photo-orientations';
import './TakePhoto.scss';

import Div100Vh from 'react-div-100vh'
import withAuth from '../../higherOrderComponents/withAuth';
import { useHistory } from 'react-router-dom';


const TakePhotoPage = () => {
  const [jobID, setJobID] = useState(null);
  const [height, setHeight] = useState(0);
  const [weight, setWeight] = useState(0);
  const [measurements, setMeasurements] = useState('');
  const [flowState, setFlowState] = useState(0);
  const [photos, setPhotos] = useState([]);
  const [photoIds, setPhotoIds] = useState([]);
  const { setIsInBodyScanMode, setIsCapturing } = useContext(CameraContext);

  const history = useHistory()

  useEffect(() => {
    setIsInBodyScanMode(true);
    setTimeout(async () => await loadMeasurements());

    return () => setIsInBodyScanMode(false);
  }, []);

  useEffect(() => {
    if (!!jobID && flowState === FlowState.PROCESSING) {
      history.push(`/job/${jobID}`)
    }
  }, [jobID])

  const loadMeasurements = async () => {
    try {
      const res = await getMeasurements();
      const measurements = res && res.data ? res.data || [] : []
      setHeight(findMetricVal('height', measurements) || 0);
      setWeight(findMetricVal('height', measurements) || 0);
      setMeasurements(measurements);
    } catch (err) {
      console.error(err);
    }
  };

  const nextFlowState = () => setFlowState(FlowState.next(flowState))

  const startJob = async () => {
    try {
      await saveMeasurements([
        { name: 'height', value: height },
        // { name: 'weight', value: weight },
      ]);
      await loadMeasurements();

      let measurementsIds = measurements.map((x) => x.id);
      const photos = {
        photo_ids: photoIds,
        measurement_ids: measurementsIds,
      };

      const response = await createAvatar(photos);
      if (response) {
        const jobId = response.data.job.id;
        setJobID(jobId);
      }
    } catch (err) {
      console.error(err);
      setFlowState(FlowState.PHOTO_ERROR);
    }
  };

  const onPhotoCaptured = (photo) => {
    console.log('photo captured', photo);
    if (!photo) {
      setFlowState(FlowState.PHOTO_ERROR);
    } else {
      setPhotos([...photos, photo]);
    }
  };

  const onVerify = () => {
    nextFlowState();
  };

  const onPhotosVerified = () => {
    console.log('photos verified');
    submitPhotos();
  };

  const onWeightEntered = () => {
    nextFlowState();
    startJob();
  };

  
  const onRestart = () => {
    
    setFlowState(FlowState.CHOOSE_FLOW_TYPE);
    setPhotos([]);
    setPhotoIds([]);
  };
  
  const onCancel = () => {
    console.log('cancelled');
    onRestart()
    history.push('/')
  };

  const submitPhotos = async () => {
    const formData = new FormData();
    photos.forEach(async (p, i) => {
      const file = dataURItoBlob(p);
      console.log(file);
      formData.append('files', file, `file_${i}`);
      formData.append('orientation_data', Orientations.OrderedSteps[i]);
    });
    try {
      const res = await postPhotos(formData);
      console.log(res);
      const ids = res.data.map((x) => x.id);
      setPhotoIds(ids);
      nextFlowState();
    } catch (err) {
      console.error(err);
      setFlowState(FlowState.PHOTO_ERROR);
    }
  };

  const onFlowTypeSelected = (val) => {
    setIsCapturing(val);
    nextFlowState();
  };

  return (
    <Div100Vh className="take-photo" id="content">
      {flowState === FlowState.CHOOSE_FLOW_TYPE && <FlowStageChooseFlowType {...{ onFlowTypeSelected, onCancel }} />}
      {flowState === FlowState.TAKE_PHOTOS && (
        <FlowStageTakePhotos {...{ onPhotoCaptured, photos, onVerify, onCancel, onRestart }} />
      )}
      {flowState === FlowState.CHECK_PHOTOS && (
        <FlowStageVerifyPhotos {...{ photos, onRestart, onCancel, onPhotosVerified }} />
      )}
      {flowState === FlowState.CONFIRM_HEIGHT && (
        <FlowStageInputMetric
          {...{ ...HeightDefaults, next: nextFlowState, metricVal: height, onInputChanged: setHeight }}
        />
      )}
      {flowState === FlowState.CONFIRM_WEIGHT && (
        <FlowStageInputMetric
          {...{ ...WeightDefaults, next: onWeightEntered, metricVal: weight, onInputChanged: setWeight }}
        />
      )}
      {/* {flowState === FlowState.PROCESSING && (
        <>
          {jobID && <JobProgressStatus jobId={jobID}></JobProgressStatus>}
          <EpicSpinner />
        </>
      )} */}
      {flowState === FlowState.PHOTO_ERROR && <FlowStageError {...{ onRestart, onCancel }} />}
    </Div100Vh>
  );
};
export default withAuth(TakePhotoPage);
